'use client';

import { useState } from 'react';
import type { FAQItem } from './types';

interface Props {
  items: FAQItem[];
}

/**
 * Accordion FAQ. Keyboard-accessible via native <details>/<summary>,
 * styled to match the rest of the page. Open state is independent per item.
 */
export default function PricingFAQ({ items }: Props) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <div className="mx-auto max-w-3xl">
      <h2 className="mb-8 text-center text-2xl font-bold tracking-tight text-slate-900">
        Frequently asked questions
      </h2>
      <div className="divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
        {items.map((item, idx) => {
          const isOpen = openIdx === idx;
          return (
            <div key={item.q}>
              <button
                type="button"
                onClick={() => setOpenIdx(isOpen ? null : idx)}
                className="flex w-full items-center justify-between px-6 py-5 text-left"
                aria-expanded={isOpen}
              >
                <span className="pr-4 text-base font-semibold text-slate-900">
                  {item.q}
                </span>
                <svg
                  className={`h-5 w-5 flex-shrink-0 text-slate-400 transition-transform ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.39a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              {isOpen && (
                <div className="px-6 pb-5 text-sm leading-relaxed text-slate-600">
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
